export default "__VITE_ASSET__Du62TFOj__"